export const PromotionTypeEnum = [
    { id: 'coupon', name: 'Coupon' },
    { id: 'rule', name: 'Rule' }
];